import { VisitTemplate, VisitTemplateRemoveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { PromiseVoidFunction, sortBeanAlphabetically } from '@dreryk/react-common';

import { FormsTemplates, FormsTemplateSortItemsFn } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../translations';

const sortVisitTemplates: FormsTemplateSortItemsFn<VisitTemplate> = (items, sortOrder) =>
   sortBeanAlphabetically(items, 'name', sortOrder, '');

type VisitTemplatesListProps = {
   readonly onTemplateRemoved: PromiseVoidFunction;
};

export const VisitTemplatesList = (props: VisitTemplatesListProps): JSX.Element => {
   return (
      <FormsTemplates.List<VisitTemplate>
         onTemplateRemoved={props.onTemplateRemoved}
         sortFn={sortVisitTemplates}
         removeConfirmationTitle={visitTemplatesTranslationKeys.deletingTemplate}
         removeSuccessMessage={visitTemplatesTranslationKeys.successfullyDeletedTemplate}
         removeCommandCreator={(templateId) => {
            const command = new VisitTemplateRemoveCommand();
            command.id = templateId;
            return command;
         }}
         testId={'visitTemplates'}
      />
   );
};
